/**
 * SuperAdminPage
 * Protected page wrapper for Super Admin Dashboard
 * Feature: User Management (002-user-management)
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import SuperAdminDashboard from '../components/SuperAdminDashboard';

const SuperAdminPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user, loading } = useAuth();

  useEffect(() => {
    if (!loading) {
      if (!isAuthenticated) {
        // Not logged in, redirect to login
        navigate('/login', { replace: true, state: { from: '/super-admin' } });
      } else if (user?.role !== 'super_admin') {
        // Logged in but not super admin, redirect to appropriate page
        if (user?.role === 'admin') {
          navigate('/admin', { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      }
    }
  }, [isAuthenticated, user, loading, navigate]);

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '1.2rem',
        color: '#667eea'
      }}>
        Loading...
      </div>
    );
  }

  // Only render dashboard if user is super admin
  if (!isAuthenticated || user?.role !== 'super_admin') {
    return null;
  }

  return <SuperAdminDashboard />;
};

export default SuperAdminPage;
